import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const GOLD = '#d8b878';
const FAQS = [{
  q: '¿Qué incluye mi compra?',
  a: 'Recibirás el ebook principal en PDF, el bono “Cuaderno de Reflexión: Despierta el Juego” y un archivo de acceso interactivo para visualizar ambos materiales en formato flipbook.'
}, {
  q: '¿Qué es el bono incluido?',
  a: 'Es un workbook de reflexión con ejercicios guiados, preguntas profundas y espacios de escritura para ayudarte a aplicar las ideas del ebook a tu propia vida.'
}, {
  q: '¿Qué es el acceso interactivo?',
  a: 'Es una versión tipo flipbook del ebook y del bono que puedes abrir desde tu navegador. También recibirás los PDFs descargables como archivos principales. El acceso interactivo está protegido y la contraseña se entrega únicamente después de la compra.'
}, {
  q: '¿El producto está en español?',
  a: 'Sí. Este producto digital está en español. Yes. This digital product is in Spanish.'
}, {
  q: '¿Cuándo recibo mis archivos?',
  a: 'Después de completar tu compra, recibirás un correo con el enlace de descarga. Dentro del archivo encontrarás el ebook, el bono y el acceso interactivo.'
}, {
  q: '¿Puedo leerlo desde mi celular?',
  a: 'Sí. Puedes leer los PDFs desde celular, tablet o computadora. También puedes abrir las versiones interactivas tipo flipbook desde tu navegador.'
}, {
  q: '¿Puedo compartir el ebook o el bono?',
  a: 'No. El contenido es para uso personal del comprador. No está permitido compartir, reenviar, revender, publicar ni distribuir el material sin autorización previa.'
}, {
  q: '¿Este ebook reemplaza terapia o ayuda profesional?',
  a: 'No. Este material es educativo, reflexivo e inspiracional. No reemplaza terapia, tratamiento médico, psicológico, psiquiátrico ni acompañamiento profesional.'
}, {
  q: '¿Hay reembolsos?',
  a: 'Al tratarse de un producto digital con entrega inmediata, la compra no es reembolsable.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(null);
  return <div className="mt-16 md:mt-24 max-w-2xl mx-auto text-left" data-id="element-90">
      {/* Header */}
      <div className="text-center mb-8 md:mb-10" data-id="element-91">
        <span className="inline-block font-inter text-[10px] md:text-xs tracking-[0.4em] uppercase mb-4" style={{
        color: 'rgba(216,184,120,0.7)'
      }} data-id="element-92">
          Antes de entrar al portal
        </span>
        <h3 className="font-cinzel text-2xl md:text-3xl text-matrix-cream drop-shadow-[0_0_12px_rgba(245,230,200,0.12)]" data-id="element-93">
          Preguntas frecuentes
        </h3>
      </div>

      {/* Accordion — single top border; no trailing divider under the last item */}
      <div className="divide-y divide-matrix-green/12 border-t border-matrix-green/15" data-id="element-94">
        {FAQS.map((faq, i) => {
        const isOpen = open === i;
        return <div key={i} data-id="element-95">
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-4 md:py-5 text-left transition-colors hover:text-matrix-cream group" data-id="element-96">
                <span className={`font-cinzel text-base md:text-lg leading-snug transition-colors ${isOpen ? 'text-matrix-cream' : 'text-matrix-white/85'}`} data-id="element-97">
                  {faq.q}
                </span>
                <span className="shrink-0 flex h-7 w-7 items-center justify-center rounded-full border transition-colors" style={{
              borderColor: isOpen ? 'rgba(216,184,120,0.5)' : 'rgba(0,255,65,0.25)',
              color: GOLD
            }} data-id="element-98">
                  {isOpen ? <MinusIcon size={15} data-id="element-99" /> : <PlusIcon size={15} data-id="element-100" />}
                </span>
              </button>

              <AnimatePresence initial={false} data-id="element-101">
                {isOpen && <motion.div key="content" initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-102">
                    <p className="pb-5 pr-9 text-sm md:text-base text-matrix-white/70 font-light leading-relaxed" data-id="element-103">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </div>;
}